<div class="section-container" id="sdk-information">
  <div class="section-header">
    <div class="title-cont">
      <img src="/assets/icons/icon-search.svg" width="21" height="26" alt="SDK Information Icon" />
      <h2>SDK Information</h2>
    </div>
  </div>

  <div class="grid-container">
    <div class="grid-item">
      <div>
        <img src="/assets/icons/icon-parent-company.svg" width="20" height="20" alt="Parent Company Icon" />
        <span>Parent Company</span>
      </div>
      <span>{{ data?.overview?.parentCompany || 'N/A'}}</span>
    </div>

    <div class="grid-item">
      <div>
        <img src="/assets/icons/icon-globe.svg" width="20" height="20" alt="SDK Website Icon" />
        <span>Website</span>
      </div>
      <span>{{ data?.overview?.sdkWebsite || 'N/A'}}</span>
    </div>

    <div class="grid-item">
      <div>
        <img src="/assets/icons/icon-location.svg" width="20" height="20" alt="SDK Country Icon" />
        <span>Country of Origin</span>
      </div>
      <div>
        <img src="//cdn.pixalate.com/icons/countries/flat/48/{{data?.overview?.sdkCountryCode}}.png"
          onerror="this.src='/assets/icons/icon-flag.png';" width="18" height="18" alt="Flag Icon"
          title="{{ data?.overview?.sdkCountry }}" data-animation="false" />
        <span>{{ data?.overview?.sdkCountry || 'Unknown' }}</span>
      </div>
    </div>

    <div class="grid-item">
      <div>
        <svg class="info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
          <line x1="7" y1="7" x2="7.01" y2="7"></line>
        </svg>
        <span>SDK Version</span>
      </div>
      <span>{{ data?.overview?.sdkVersion || 'N/A' }}</span>
    </div>

    <div class="grid-item">
      <div>
        <svg class="info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>Version Published</span>
      </div>
      <span>{{ data?.overview?.lastUpdatedDate || 'N/A' }}</span>
    </div>

    <div class="grid-item">
      <div>
        <svg class="info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7" rx="1"></rect>
          <rect x="14" y="3" width="7" height="7" rx="1"></rect>
          <rect x="14" y="14" width="7" height="7" rx="1"></rect>
          <rect x="3" y="14" width="7" height="7" rx="1"></rect>
        </svg> <span>App Count</span>
      </div>
      <span>{{ (data?.appDetails?.appCount | roundsig) || 'N/A' }}</span>
    </div>

    <div class="grid-item">
      <div>
        <svg class="info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg> <span>Est. Downloads</span>
      </div>
      <span>{{ data?.overview?.consumerReachRange || 'N/A' }}</span>
    </div>

    <div class="grid-item">
      <div>
        <svg class="info-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="6" r="3"></circle>
          <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"></path>
          <path d="M9 11l-2 4M15 11l2 4"></path>
        </svg> <span>Child-Directed Apps</span>
      </div>
      <span>{{ (data?.appDetails?.childDirectedAppsCount | roundsig) || 'N/A' }}</span>
    </div>
  </div>
</div>

<div class="more-info-container">
  <div class="section-container">
    <ng-container *ngTemplateOutlet="affectedAppsTemplate; context: { 
      collapseId: 'child-directed-apps', 
      title: 'What apps is the SDK installed on?',
      apps: data?.appDetails?.topApps || []
    }"></ng-container>
  </div>

  <!-- <div class="section-container">
    <ng-container *ngTemplateOutlet="dataBrokersTemplate; context: { 
      collapseId: 'tracking-domains', 
      title: 'Tracking Domains',
      data: data?.riskOverview?.trackingDomains || []
    }"></ng-container>
  </div> -->

  <div class="section-container">
    <ng-container *ngTemplateOutlet="evidenceTemplate; context: { 
      collapseId: 'selected-evidence', 
      title: 'What is the code evidence for location data collection?',
      data: data?.appDetails?.selectedEvidence || []
    }"></ng-container>
  </div>
</div>

<ng-template #affectedAppsTemplate let-title="title" let-collapseId="collapseId" let-apps="apps" let-tooltip="tooltip">
  <div class="d-flex align-items-center">
    <h3>{{ title }} <i class="fa fa-info-circle ml-2 tooltip-icon" *ngIf="tooltip" enTooltip [attr.title]="tooltip"></i>
    </h3>
  </div>

  <ng-container *ngIf="apps.length == 0">
    No sample apps observed
  </ng-container>
  <ng-container *ngIf="apps.length > 0">
    <div class="nav-item">
      <a class="btn btn-link affected-apps collapsed hasCount" data-toggle="collapse"
        href="#collapseExample{{collapseId}}" role="button" aria-expanded="false"
        aria-controls="collapseExample{{collapseId}}">
        Sample Apps
      </a>
    </div>
    <div class="collapse" id="collapseExample{{collapseId}}">
      <div class="d-flex flex-column">
        <ng-container *ngFor="let app of apps">
          <a class="btn btn-link btn-app text-left"
            [routerLink]="['/insight/apps', app.appId, 'GLOBAL', app.appId | appStoreMap, 'GLOBAL']">
            <img src="{{ app?.appIcon }}" alt="{{ app.appName }} Icon" class="mr-2 rounded" [attr.width]="'48'"
              [attr.height]="'48'" onerror="this.src='/assets/icons/icon-72x72-grey.png'" />
            <div class="appTitle">{{ app.appName }}</div>
          </a>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #dataBrokersTemplate let-title="title" let-collapseId="collapseId" let-domainsData="data"
  let-tooltip="tooltip">
  <div class="d-flex align-items-center">
    <h3>{{ title }} <i class="fa fa-info-circle ml-2 tooltip-icon" *ngIf="tooltip" enTooltip [attr.title]="tooltip"></i>
    </h3>
  </div>

  <div class="nav-item" *ngIf="domainsData.length == 0">
    No domains observed
  </div>
  <ng-container *ngIf="domainsData.length > 0">
    <div class="nav-item">
      <a class="btn btn-link affected-apps collapsed hasCount" data-toggle="collapse"
        href="#collapseExample{{collapseId}}" role="button" aria-expanded="false"
        aria-controls="collapseExample{{collapseId}}">
        Websites ({{ domainsData.length }})
      </a>
    </div>
    <div class="collapse" id="collapseExample{{collapseId}}">
      <div class="d-flex flex-column">
        <ng-container *ngFor="let website of domainsData">
          <span class="ml-2 title">{{ website }}</span>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #evidenceTemplate let-title="title" let-collapseId="collapseId" let-evidenceData="data"
  let-tooltip="tooltip">
  <div class="d-flex align-items-center">
    <h3>{{ title }} <i class="fa fa-info-circle ml-2 tooltip-icon" *ngIf="tooltip" enTooltip [attr.title]="tooltip"></i>
    </h3>
  </div>

  <div class="nav-item" *ngIf="evidenceData.length == 0">
    No evidence observed
  </div>
  <ng-container *ngIf="evidenceData.length > 0">
    <div class="nav-item d-flex flex-column align-items-start">
      <a class="btn btn-link p-0 pb-2"
        href="https://pixalate.com/sdk-trust-index-evidence-dashboard#sdk-{{data.sdkId}}-{{data?.overview?.appStore}}"
        target="_blank" role="button">
        View Full Code Analysis
      </a>
      <a class="btn btn-link affected-apps collapsed hasCount" data-toggle="collapse"
        href="#collapseExample{{collapseId}}" role="button" aria-expanded="false"
        aria-controls="collapseExample{{collapseId}}">
        View Code Snippet
      </a>
    </div>
    <div class="collapse" id="collapseExample{{collapseId}}">
      <div class="d-flex flex-column">
        <app-code-snippet [data]="evidenceData"></app-code-snippet>
      </div>
    </div>
  </ng-container>
</ng-template>